import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Feature } from '../Feature.mjs';
var id = 0;
var ExitAnimationFeature = /*#__PURE__*/function (_Feature) {
  function ExitAnimationFeature() {
    var _this;
    _classCallCheck(this, ExitAnimationFeature);
    _this = _callSuper(this, ExitAnimationFeature, arguments);
    _this.id = id++;
    return _this;
  }
  _inherits(ExitAnimationFeature, _Feature);
  return _createClass(ExitAnimationFeature, [{
    key: "update",
    value: function update() {
      var _this2 = this;
      if (!this.node.presenceContext) return;
      var _this$node$presenceCo = this.node.presenceContext,
        isPresent = _this$node$presenceCo.isPresent,
        onExitComplete = _this$node$presenceCo.onExitComplete;
      var _ref = this.node.prevPresenceContext || {},
        prevIsPresent = _ref.isPresent;
      if (!this.node.animationState || isPresent === prevIsPresent) {
        return;
      }
      var exitAnimation = this.node.animationState.setActive("exit", !isPresent);
      if (onExitComplete && !isPresent) {
        exitAnimation.then(function () {
          return onExitComplete(_this2.id);
        });
      }
    }
  }, {
    key: "mount",
    value: function mount() {
      var _ref2 = this.node.presenceContext || {},
        register = _ref2.register;
      if (register) {
        this.unmount = register(this.id);
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);
export { ExitAnimationFeature };